import { cloneElement, lazy, Suspense, useState, type ReactElement } from "react";

// Lazy wrapper around PremiumDialog so the Paddle checkout SDK and dialog
// code are not shipped in the landing page's initial JS bundle. The trigger
// renders immediately; the actual dialog module is fetched on first click.
const PremiumDialog = lazy(() =>
  import("./PremiumDialog").then((m) => ({ default: m.PremiumDialog })),
);

type TriggerElement = ReactElement<{ onClick?: (e: unknown) => void }>;

export function PremiumDialogLazy({ trigger }: { trigger: TriggerElement }) {
  const [loaded, setLoaded] = useState(false);
  const [open, setOpen] = useState(false);

  const handleClick = () => {
    setLoaded(true);
    setOpen(true);
  };

  const placeholder = cloneElement(trigger, { onClick: handleClick });

  if (!loaded) return placeholder;

  return (
    <Suspense fallback={placeholder}>
      <PremiumDialog open={open} onOpenChange={setOpen} trigger={trigger} />
    </Suspense>
  );
}